// charts-core.ts
// import ApexCharts from 'apexcharts';

const HEX_NEUTRAL_900 = '#171717';  // Tailwind neutral-900

const palette = (dark) => ({
  fore: dark ? '#e5e7eb' : '#334155',
  grid: dark ? '#303030' : '#e5e7eb',
  tooltipTheme: dark ? 'dark' : 'light',
  bg: dark ? HEX_NEUTRAL_900 : '#ffffff'
});

export const SERIES_COLORS = ['#2563eb', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#14b8a6', '#22c55e', '#f472b6'];

export const baseOpts = (dark, overrides = {}) => {
  const c = palette(dark);
  return {
    chart: {
      background: c.bg,        // ← dark: neutral-900
      height: 280,
      foreColor: c.fore,
      zoom: { enabled: false },
      selection: { enabled: false },
      toolbar: { show: false, tools: { selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false } }
    },
    grid: { borderColor: c.grid },
    tooltip: { theme: c.tooltipTheme },
    theme: { mode: dark ? 'dark' : 'light' },
    dataLabels: { style: { colors: [c.fore] } },
    responsive: [
      { breakpoint: 1024, options: { chart: { height: 260 } } },
      { breakpoint: 640,  options: { chart: { height: 220 } } }
    ],
    ...overrides
  };
};
